import { PaymentsLanding } from "components/PaymentsLanding/PaymentsLanding";
import { createFileRoute } from "@tanstack/react-router";
import type { SettingsModalSearchParams } from "components/PaymentsLanding/SettingsModal/usePaymentDashboardSettingsModal";

export const Route = createFileRoute("/history")({
    component: PaymentsLanding,
    validateSearch: (search: SettingsModalSearchParams): SettingsModalSearchParams => {
        return {
            settingsOpen: search.settingsOpen === true,
            settingsTab: search.settingsTab,
        } satisfies SettingsModalSearchParams;
    },
});
